// Environment Configuration
// Get them from: https://supabase.com/dashboard → Your Project → Settings → API

export const ENV = {
  SUPABASE_URL: 'https://vlksqapzelwjqsdejlzf.supabase.co',
  SUPABASE_ANON_KEY: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZsa3NxYXB6ZWx3anFzZGVqbHpmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk0Mjk2MDUsImV4cCI6MjA3NTAwNTYwNX0.VSCUl1LuM-jnPe10LdQ9DqbSfuYtyLeLTVtrlszG_tE',
}

